import React from "react";
import { Container, Row, Col } from "shards-react";
import CreditNote from "../components/invoicing/CreditNote";
import CreditNotes from "../components/invoicing/CreditNotes";

const CreditNotesView = props => {
  const { client_id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <CreditNotes client_id={client_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default CreditNotesView;
